<app-base-modal
  [title]="certificateResourceType.name"
  [showStateToggle]="isValid"
>
  <div class="wrapper">
    <mat-accordion [multi]="true">
      @for (certificate of certificatesData; track $index) {
        <mat-expansion-panel [expanded]="certificate.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="title">
                <div class="title-text">
                  {{ certificate.certificateNumber }}
                </div>
                @if (!!certificate.id && isEditModeActive) {
                  <button
                    mat-mini-fab
                    class="btn-delete"
                    (click)="handleDelete($event, certificate.id, $index)"
                  >
                    <mat-icon class="btn-delete-icon">delete</mat-icon>
                  </button>
                }
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-certificate-form
            [parentId]="certificateDialogData.parentId"
            [certificateData]="certificate"
            [certificateFormGroup]="certificateFormGroups[$index]"
            [noFirstData]="noFirstData"
            [isEditModeActive]="isEditModeActive"
            (updateCertificateData)="updateCertificateData($event, $index)"
            (deleteCertificate)="deleteCertificate($index)"
          />
          @if (certificate.id) {
            <div
              class="certificate-files"
              app-certificate-files
              [certificateId]="certificate.id"
              [isEditModeActive]="isEditModeActive"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      type="button"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid"
      (click)="handleAddNew()"
    >
      Добавить новый
    </button>
  </div>
</app-base-modal>
